import { BodyM } from '@casavo/base-ui'
import cn from 'classnames'
import { useField } from 'formik'
import useTranslation from 'next-translate/useTranslation'

import { Divider } from '@/design-lib/components/Divider'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { theme } from '@/design-lib/theme'
import { flexCenter, gap } from '@/shared-styles/styles.css'
import { handleClick } from '@/utils/tracking/eventsHandlers'

import { ConceptImage } from '../ConceptImage'
import Icon from '../Icon'

import { InfoSelectionEnum } from './RequestContactFlow'
import { divider, requestInfoReasonButton } from './styles.css'

type Props = {
  onSelection: (itemSelected: InfoSelectionEnum) => void
}

const getEventOnInfoSelection = (infoValue: InfoSelectionEnum) => {
  switch (infoValue) {
    case InfoSelectionEnum.MORE_PHOTOS:
      return 'ReasonList-Photo'
    case InfoSelectionEnum.OTHER:
      return 'ReasonList-Question'
    case InfoSelectionEnum.VISIT:
      return 'ReasonList-Visit'
  }
}

export const RequestInfo: React.FC<Props> = ({ onSelection }) => {
  const [_, { value: reason }, { setValue: setReason }] = useField('reason')
  const { t } = useTranslation()

  const onItemClicked = (infoValue: InfoSelectionEnum) => {
    handleClick('RequestCallModal', getEventOnInfoSelection(infoValue))
    if ([InfoSelectionEnum.MORE_PHOTOS, InfoSelectionEnum.OTHER].includes(infoValue)) {
      setReason(infoValue)
    }
    onSelection(infoValue)
  }

  return (
    <div className={sprinkles({ paddingBottom: 'l' })}>
      <button
        className={cn(requestInfoReasonButton, sprinkles({ marginBottom: 'l' }))}
        onClick={() => onItemClicked(InfoSelectionEnum.MORE_PHOTOS)}
      >
        <div className={cn(flexCenter, gap.m)}>
          <ConceptImage height={50} name="home-chapter" width={50} />
          <BodyM>{t('listing-detail:RequestCallModal_Reasonlist_MorePhoto')}</BodyM>
        </div>
        <Icon.Chevron />
      </button>
      <button className={requestInfoReasonButton} onClick={() => onItemClicked(InfoSelectionEnum.OTHER)}>
        <div className={cn(flexCenter, gap.m)}>
          <ConceptImage height={50} name="faq1" width={50} />
          <BodyM>{t('listing-detail:RequestCallModal_Reasonlist_Questions')}</BodyM>
        </div>
        <Icon.Chevron />
      </button>
      <Divider className={divider} />
      <button className={requestInfoReasonButton} onClick={() => onSelection(InfoSelectionEnum.VISIT)}>
        <div className={cn(flexCenter, gap.m)}>
          <ConceptImage height={50} name="home-chapter-woman" width={50} />
          <BodyM>{t('listing-detail:RequestCallModal_Reasonlist_Visit')}</BodyM>
        </div>
        <Icon.Chevron />
      </button>
    </div>
  )
}
